import { useAppSelector } from '../../redux/hooks';
import { getTenantName } from '../../utility/utility';
import placeholderLogo from './../../assets/logo-placeholder.png';
import React from 'react';

const Logo = ({ classNames }: { classNames: string }) => {
  const { auth } = useAppSelector((state) => state.assestsReducers);

  // Use logo from assests if available or else if resolve from hostname
  let logo = auth?.logo;

  // If not available from /config/assets then resolve it from locally
  if (!logo) {
    const tenantName = getTenantName();
    const tennatUrl = tenantName
      ? `${process.env.PUBLIC_URL}/${tenantName}/`
      : '';
    const svgUrl = tennatUrl + 'logo.svg';
    const pngUrl = tennatUrl + 'logo.png';
    logo = svgUrl || pngUrl || placeholderLogo;
  }
  return (
    <>
      <div className={`${classNames} header_logo_wrapper`}>
        <img
          src={logo || placeholderLogo}
          className={'logo'}
          alt={'App Logo'}
        />
      </div>
    </>
  );
};

export default Logo;
